var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.25a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM7.5 16.75a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM21.384 4.3a.76.76 0 00-.6-.3H4.528l-.76-2.663A1.51 1.51 0 002.326.25H.75a.75.75 0 000 1.5h1.575l.919 3.197v.019l2.475 8.653a2.26 2.26 0 002.165 1.631h8.982a2.26 2.26 0 002.165-1.631l2.475-8.663a.748.748 0 00-.122-.656z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/E-commerce.4e67c239e18aa81c9d9fa19f56a0c63f.svg";
export { ForwardRef as ReactComponent };